import React from 'react';
import DriverLicenseStart from 'features/DriverLicense/DriverLicenseStart';

import { RouteComponentProps } from 'react-router';

const PrequalDriverLicenseStart: React.FC<RouteComponentProps> = props => {
  return <DriverLicenseStart {...props} />;
};

export default PrequalDriverLicenseStart;
